// Modul zur Anzeige des Standard-Zuschusses
"use strict";

import module from "./module.js";
import "./tests.spec.js";

export default module;
